/// <reference path="../global.d.ts" />

import '../../../librerias/autocomplete/jquery.autocomplete.js'
import '../../../librerias/autocomplete/autocomplete.styl'

import 'bootstrap/js/dist/tooltip';

import { Http } from "../http";
import { Utils } from "../utils";
import { SelectorFechas } from "./selectorFechas";
import { Forms } from '../forms';

declare global {
	interface JQuery {
		jautocomplete(options: any): any;
	}
}

declare global {
	interface Window {
		tarifas: any;
	}
}

var showRates = () => { };


export class Buscador {

	utils = new Utils();

	selector_fechas: SelectorFechas = new SelectorFechas();
	ciudadi_name: string = '';
	ciudadf_name: string = '';

	iniciar() {
		this.autocompleteCiudad(() => {
			this.selector_fechas.instanceDate();
			this.selector_fechas.setValoresInicialesSelector();
			this.initSwitch();
			this.listenDevolverEnOtroPunto();
		}, null);
		this.initInputClearButton();

		let self = this;

		$('#buscar').on('click', function (event) {
			event.preventDefault();

			let form = new Forms();

			if (form.validarCampo($('#ciudadi-str'), ['required']) || form.validarCampo($('#ciudadi'), ['required'])) {
				self.showError($('#ciudadi-contenedor'), x_textos['525-0']);
				return;
			}

			if ($('#switch-otro-punto').prop('checked')) {
				if (form.validarCampo($('#ciudadf-str'), ['required']) || form.validarCampo($('#ciudadf'), ['required'])) {
					self.showError($('#ciudadf-contenedor'), x_textos['525-1']);
					return;
				}
			}

			// Obtener el texto original del botón
			var originalText = $(this).text();


			// Mostrar el spinner durante 5 segundos
			$(this).html(`
				<div class="spinner-border text-light" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			`);

			// Restaurar el texto original después de 5 segundos
			setTimeout(() => {
				$(this).html(originalText);
			}, 5000);

			$('#form-busqueda').trigger('submit');
		});
	}

	showError($container: JQuery, text: string) {
		$container.addClass('border border-danger').find('label').addClass('text-danger');
		$container.tooltip({ title: text, trigger: 'manual', customClass: 'tooltip-search' });
		$container.tooltip('show');
		setTimeout(() => {
			$container.removeClass('border border-danger').find('label').removeClass('text-danger');
			$container.tooltip('hide');
		}, 4000);
	}


	/**
	 * Método para inicializar el autocomplente del buscador
	 * @param callback callback a ejecutar una vez inicializado el auto complete
	 * @param showRatesFilter funcion a ejecutar si hay tarifas
	 */
	autocompleteCiudad(callback: any, showRatesFilter = null) {

		var self = this;
		let maxHeight = 'auto';

		if (showRatesFilter) showRates = showRatesFilter;

		/** Método para cargar el nombre de la ciudad actual buscada en el input */
		let ciudadi = $('#ciudadi').val()
			, ciudadf = $('#ciudadf').val()
		if (ciudadi != '') {
			$.get('/ciudades/' + alk_lang + '/'
				, { idcomp: [ciudadi, ciudadf] }
				, function (data) {
					for (let i in data.suggestions) {
						let suggestion = data.suggestions[i]
						if (suggestion.idcomp == ciudadi) {
							self.putInCiudades('ciudadi', suggestion);

						}
						if (suggestion.idcomp == ciudadf) {
							self.putInCiudades('ciudadf', suggestion);
						}
					}

					if (typeof callback == 'function') {
						callback()
					}
				}
				, 'json')
		}
		else if (typeof callback == 'function') {
			callback()
		}

		// Para detectar si la ciudad fue seleccionada de la lista de sugerencias. (Comentador por que no se para que sirve)
		/*
		$('#ciudadi-str, #ciudadf-str').on('keydown', function (e) {
			let $this = $(this)
			$this.attr('data-selected-list', false)
			if (e.keyCode === 13) $this.attr('data-selected-list', true);
		}) */


		/** 
		 * Método para escuchar cuando se escriba algo en el input de ciudad de recogida
		 * Se solicitan las ciudadades en base a un termino y se agregan al autocomplete en forma de lista
		 */
		const ciudadiAutocomplete = $('#ciudadi-str').jautocomplete({
			serviceUrl: '/ciudades/' + alk_lang + '/',
			dataType: 'json',
			paramName: 'term',
			maxHeight: maxHeight,
			autoSelectFirst: false,
			triggerSelectOnValidInput: false,
			preventBadQueries: false,
			beforeRender: function (container: any, suggestions: any) {
				if (self.ciudadi_name !== $('#ciudadi-str').val()) {
					$('#ciudadi').val('');
				}
				self.fixSuggestion(container, suggestions, 'ciudadi')
			},
			onSelect: function (suggestion: any, where: any) {
				if (where == 'CLICK' || where == 'RETURN') {
					self.putInCiudades('ciudadi', suggestion);
					/*
					if (typeof callback == 'function') {
						callback()
					} */
					//(Comentador por que no se para que sirve)
					//if (fechai != undefined && init) fechai.open()
				}
			}
		});

		/** 
		 * Método para escuchar cuando cambie la ciudad de devolucion 
		 * Se solicitan las ciudadades en base a un termino y se agregan al autocomplete en forma de lista
		*/
		const ciudadfAutocomplete = $('#ciudadf-str').jautocomplete({
			serviceUrl: '/ciudades/' + alk_lang + '/',
			dataType: 'json',
			paramName: 'term',
			maxHeight: maxHeight,
			autoSelectFirst: false,
			triggerSelectOnValidInput: false,
			preventBadQueries: false,
			beforeRender: function (container: any, suggestions: any) {
				$('#ciudadf').val('');
				self.fixSuggestion(container, suggestions, 'ciudadf')
			},
			onSelect: function (suggestion: any, where: any) {
				if (where == 'CLICK' || where == 'RETURN') {
					self.putInCiudades('ciudadf', suggestion);
					//(Comentador por que no se para que sirve)
					//if (fechaf != undefined && init) fechaf.open()
				}
			}
		});

		$(window).off('scroll');
		$(window).on('scroll', () => {
			ciudadiAutocomplete.jautocomplete('hide');
			ciudadfAutocomplete.jautocomplete('hide');
		});
	}

	/**
	 * Método para agregar el listado 
	 * @param tipo 
	 * @param suggestion 
	 */
	putInCiudades(tipo: any, suggestion: any) {
		if (tipo == 'ciudadi') {
			let $thisSTR = $('#ciudadi-str')
				, $otherSTR = $('#ciudadf-str')

			this.ciudadi_name = suggestion.value;
			this.ciudadf_name = suggestion.value;
			// Obtener Festivos		 
			$('#fechai-recogida, #fechaf-devolucion').attr({ 'data-id_pais': suggestion.idPais, 'data-tz': suggestion.tz })

			//this.putSearchIcon($thisSTR, suggestion.tipo)
			//this.putSearchIcon($otherSTR, suggestion.tipo)
			$thisSTR.attr('data-selected-list', 1)

			$thisSTR.val(suggestion.value)
			$('#ciudadi').val(suggestion.idcomp)
			$('#clasei').val(suggestion.clase)

			$otherSTR.val(suggestion.value)
			$('#ciudadf').val(suggestion.idcomp)
			$('#clasef').val(suggestion.clase)
			this.evalShowRates(suggestion);
		}
		else if (tipo == 'ciudadf') {
			$('#fechaf-devolucion').attr({ 'data-id_pais': suggestion.idPais, 'data-tz': suggestion.tz })

			let $thisSTR = $('#ciudadf-str')
			this.ciudadf_name = suggestion.value;
			//this.putSearchIcon($thisSTR, suggestion.tipo)
			$thisSTR.attr('data-selected-list', 1)
			$thisSTR.val(suggestion.value)
			$('#ciudadf').val(suggestion.idcomp)
			$('#clasef').val(suggestion.clase)
		}
	}

	evalShowRates(suggestion: any) {
		if (suggestion.ac == 1) {
			this.setRates(suggestion)
		}
		else {
			window.tarifas = undefined;
		}
	}

	setRates(suggestion_data: any) {
		let source = $('[name="source"]').val()
		//TEST  
		let config = { dir: '/action/getRates/', type: 'POST' },
			option = { ciudadi: suggestion_data.idcomp, source: source, csrf_token: this.utils.getCsrfToken()};

		let http = new Http();

		http.jSONInfo(config, option, function (data: any) {
			if (data['ans']['ac_rates']) {
				let tarifas = data['ans']['ac_rates'];
				if (tarifas){ 
					window.tarifas = tarifas;
					$(window).trigger('tarifas');
				}
			}
		});
	}

	/**
	 * Método par agaregar los estilos a las opciones en el autocomplete de una ciudad
	 * @param container 
	 * @param suggestions 
	 * @param selected 
	 */
	fixSuggestion(container: any, suggestions: any, selected: any) {

		for (let ii in suggestions) {
			let $suggestion = container.find('[data-index="' + ii + '"]')
				, ciudad = suggestions[ii]
				, _icono = this.getClassIcon(ciudad.tipo)
				, text = '<span class="title">' + ciudad.name + '</span>'
				, subname = '<span class="sub-title">' + this.utils.findText(ciudad.subname) + '</span>'
				, icono = '<i class="fa ' + _icono.icono + ' fa-fw" aria-hidden="true"></i>'
				, someClass = _icono.someClass
				, selected_val = $('#' + selected).val()

			if (selected_val == ciudad.idcomp) {
				someClass = someClass + ' autocomplete-selected selected-click';
			}
			$suggestion.addClass(someClass)
			$suggestion.html(`<div class='${_icono.someClass} icon'><div class="rombo"></div>${icono}${_icono.extraWord}</div><div class="text">${text}${subname}</div>`)
		}
		this.updatePositionSelector();
	}

	updatePositionSelector() {
		const $elementoHijo = $('#ciudadi-contenedor');
		const $padre = $elementoHijo.closest('.selector-ciudades-container');
		const $container_suggestions = $('.autocomplete-suggestions');
		const posicionLeftDelPadre = $padre?.offset()?.left;
		const posicionTopDelPadre = $padre?.offset()?.top;
		const ancho = $padre.width();
		const alto = $padre.height();
		if (ancho && alto && posicionLeftDelPadre && posicionTopDelPadre) {
			let top = (posicionTopDelPadre + alto) + 5;
			setTimeout(() => {
				$container_suggestions.css('left', `${posicionLeftDelPadre}px`);
				$container_suggestions.css('top', `${top}px`);
				$container_suggestions.css('width', `${ancho}px`);
				//$container_suggestions.css('display', `block`);
			}, 0.001)

		}
	}

	/**
	 * Método para determinar si una opcion del listado de ciudades es ciudad aeropuerto o a domicilio
	 * @param tipo 
	 * @returns 
	 */
	getClassIcon(tipo: any) {
		let icono = 'fa-building', someClass = 'normal', extraWord = ''

		switch (tipo.trim().toLowerCase()) {
			case 'aeropuerto':
				extraWord = x_textos['M23-1']
				someClass = 'aeropuerto'
				icono = 'fa-plane'
				break

			case 'ciudad':
				extraWord = x_textos['M162-0']
				someClass = 'ciudad'
				icono = 'fa-building'
				break

			case 'ciudad especial':
				extraWord = x_textos['M162-0']
				someClass = 'especial'
				icono = 'fa-map-marker-alt'
				break;

			case 'google_maps':
				extraWord = x_textos['M162-0']
				someClass = 'resaltada'
				icono = 'fa-map'
				break;

			case 'a domicilio':
				extraWord = x_textos['622-1']
				someClass = 'domicilios'
				icono = 'fa-car'
				break
		}

		return { icono: icono, someClass: someClass, extraWord: extraWord }
	}

	/**
	 * Método que muestra u oculta los input de busqueda 
	 * segun las preferencias del usuario
	 */
	initSwitch() {
		if ($('#switch-otro-punto').prop('checked')) {

			if ($('#ciudadi').val() === $('#ciudadf').val()) {
				$('#ciudadf-str').val('')
				$('#ciudadf').val(0)
				$('#clasef').val(0)
			}
			// reducimos el input de ciudad de recogida
			$('#ciudadi-contenedor').addClass('me-2');

			// mostramos el input de entrega en otra ciudad
			$('#ciudadf-contenedor').css('display', 'block');
			//$('#ciudadf-contenedor').slideDown(400)
		}
		else {
			/** Seteamos los valor de la ciudad inicial a la final */
			let ciudadi_str = $('#ciudadi-str').val();
			if (typeof ciudadi_str === 'string') $('#ciudadf-str').val(ciudadi_str)

			let ciudadi = $('#ciudadi').val();
			if (typeof ciudadi === 'string') $('#ciudadf').val(ciudadi);

			let clasei = $('#clasei').val();
			if (typeof clasei === 'string') $('#clasef').val(clasei);

			/** Ocultamos el input de ciudad final */
			$('#ciudadf-contenedor').css('display', 'none');
			$('#ciudadi-contenedor').removeClass('me-2');
		}
	}

	/**
	 * Método que escucha cuando cambia el switch del buscador
	 * devolver en otro punto
	 */
	listenDevolverEnOtroPunto() {
		let self = this;
		$('#switch-otro-punto').on('change', function () {
			self.initSwitch()
		})
	}

	initInputClearButton() {
		$('.input-clear-button').each(function () {
			const $btn = $(this);
			const $input = $btn.parent().find('input[type="text"]');
			const handlerShow = () => {
				if ($input.val() == '') $btn.hide();
				else $btn.show();
			};
			$btn.on('click', () => {
				$input.trigger('focus');
				setTimeout(() => $input.val(''), 100);
			});
			$input.on('input', handlerShow);
			setInterval(handlerShow, 100);
		});
	}
}